// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import { getCookie } from "../config/webStorage";

// const Chat = ({ conversationPhone }) => {
//   const token = getCookie("sctoken");
//   const messagesEndRef = useRef(null);
//   const [conversation, setConversation] = useState([]);
//   const [phone, setPhone] = useState("");
//   const [name, setName] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   console.log("conversation", conversation);
//   console.log("conversationPhone", conversationPhone);

//   // Fetch conversation data from API
//   useEffect(() => {
//     const fetchConversation = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const response = await axios.post(
//           // `${apiurl}/apis/analytics/customerchat/${conversationPhone}`,
//           `${apiurl}/apis/getMessagesByPhone`,
//           {
//             phone: conversationPhone,
//           },
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );
//         if (response.data.success) {
//           console.log("asdf", response.data);
//           setConversation(response?.data?.messages || []);
//           setPhone(response?.data?.data?.phone);
//           setName(response?.data?.data?.name);
//         } else {
//           setError("Failed to load conversation");
//         }
//       } catch (err) {
//         setError("Error fetching conversation: " + err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (conversationPhone) {
//       fetchConversation();
//     }
//   }, [conversationPhone, token]);

//   // Scroll to bottom on mount and when conversation updates
//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [conversation]);

//   // Render array-based messages (e.g., main menu)
//   const renderArrayMessage = (items) => {
//     return (
//       <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//         {items.map((item, index) => (
//           <div
//             key={item.id || index}
//             className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow cursor-pointer"
//           >
//             <h3 className="text-lg font-semibold text-primary">{item.title}</h3>
//             <p className="text-sm text-gray-600">{item.description}</p>
//           </div>
//         ))}
//       </div>
//     );
//   };

//   // Render store message
//   const renderStoreMessage = (store) => {
//     return (
//       <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm">
//         <h3 className="text-lg font-semibold text-primary">{store.fcName}</h3>
//         <p className="text-sm text-gray-600">
//           {store.streetNo}, {store.streetName}, {store.city}, {store.postCode}, {store.country}
//         </p>
//         <p className="text-sm text-gray-600">
//           <strong>Contact:</strong> {store.contactNo} ({store.contactPerson})
//         </p>
//         <p className="text-sm text-gray-600">
//           <strong>Hours:</strong> {store.openingTime} - {store.closingTime}
//         </p>
//         <p className="text-sm text-gray-600">
//           <strong>Brands:</strong>{" "}
//           {store.brand.map((b) => b.brandName).join(", ")}
//         </p>
//         <p className="text-sm text-gray-600">
//           <strong>Distance:</strong> {store.distance.toFixed(2)} km
//         </p>
//       </div>
//     );
//   };

//   // Render individual message
//   const renderMessage = (msg, index) => {
//     const isUser = msg.sender === "user";
//     const isArrayMessage = Array.isArray(msg.message);
//     const isStoreMessage = msg.message_id === "Stores" && typeof msg.message === "object" && !isArrayMessage;

//     return (
//       <div
//         key={index}
//         className={`mb-4 flex ${isUser ? "justify-start" : "justify-end"}`}
//       >
//         <div
//           className={`max-w-[70%] p-3 rounded-lg ${
//             isUser ? "bg-gray-100 text-primary" : "bg-[#f0f4ff] text-gray-800"
//           }`}
//         >
//           {isArrayMessage ? (
//             renderArrayMessage(msg.message)
//           ) : isStoreMessage ? (
//             renderStoreMessage(msg.message)
//           ) : typeof msg.message === "string" ? (
//             <p>{msg.message}</p>
//           ) : (
//             <pre className="text-xs">{JSON.stringify(msg.message, null, 2)}</pre>
//           )}
//           <small className={`text-xs opacity-70 block mt-1 ${
//             isUser ? "text-left" : "text-right"
//           }`}>
//             {new Date(msg.timestamp).toLocaleTimeString()}
//           </small>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="bg-[#fffdfc] relative h-full w-full flex flex-col">
//       {/* Header with phone number */}
//       <div className="bg-primary text-white p-4 text-lg font-semibold">
//         Conversation with {name ? name : phone}
//       </div>

//       {/* Messages container */}
//       <div className="flex-1 overflow-y-auto hide-scrollbar p-5 flex flex-col">
//         {loading ? (
//           <div className="flex-1 flex items-center justify-center">
//             <p className="text-gray-500">Loading...</p>
//           </div>
//         ) : error ? (
//           <div className="flex-1 flex items-center justify-center">
//             <p className="text-red-500">{error}</p>
//           </div>
//         ) : conversation.length > 0 ? (
//           conversation.map(renderMessage)
//         ) : (
//           <div className="flex-1 flex items-center justify-center">
//             <p className="text-gray-500">No messages yet</p>
//           </div>
//         )}
//         <div ref={messagesEndRef} />
//       </div>
//     </div>
//   );
// };

// export default Chat;

// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import { getCookie } from "../config/webStorage";

// const Chat = ({ conversationPhone }) => {
//   const token = getCookie("sctoken");
//   const messagesEndRef = useRef(null);
//   const [conversation, setConversation] = useState([]);
//   const [phone, setPhone] = useState("");
//   const [name, setName] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch conversation data from API
//   useEffect(() => {
//     const fetchConversation = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const response = await axios.post(
//           `${apiurl}/apis/getMessagesByPhone`,
//           { phone: conversationPhone },
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         if (response.data.success) {
//           setConversation(response?.data?.messages || []);
//           setPhone(response?.data?.data?.phone);
//           setName(response?.data?.data?.name);
//         } else {
//           setError("Failed to load conversation");
//         }
//       } catch (err) {
//         setError("Error fetching conversation: " + err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (conversationPhone) {
//       fetchConversation();
//     }
//   }, [conversationPhone, token]);

//   // Scroll to bottom on mount and when conversation updates
//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [conversation]);

//   // Render buttons for messages with actions
//   const renderButtons = (buttons) => {
//     return (
//       <div className="mt-2 flex flex-wrap gap-2">
//         {buttons.map((button, idx) => (
//           <button
//             key={button.id || idx}
//             className="px-3 py-1 bg-primary text-white rounded-md hover:bg-primary-dark transition-colors text-sm"
//             onClick={() => console.log(`Button clicked: ${button.id}`)} // Replace with actual handler
//           >
//             {button.title}
//           </button>
//         ))}
//       </div>
//     );
//   };

//   // Render item feedback message (with image, body, footer, buttons)
//   const renderItemFeedbackMessage = (content) => {
//     return (
//       <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm max-w-md">
//         {content.header?.type === "IMAGE" && (
//           <img
//             src={content.header.mediaUrl}
//             alt="Item"
//             className="w-full h-40 object-cover rounded-md mb-3"
//             onError={(e) => (e.target.src = "https://via.placeholder.com/150")} // Fallback image
//           />
//         )}
//         <div className="text-sm text-gray-800">
//           {content.body?.text.split("\n").map((line, idx) => (
//             <p key={idx} className="mb-1">
//               {line}
//             </p>
//           ))}
//         </div>
//         {content.footer?.text && (
//           <p className="text-xs text-gray-500 mt-2">{content.footer.text}</p>
//         )}
//         {content.action?.buttons && renderButtons(content.action.buttons)}
//       </div>
//     );
//   };

//   // Render order feedback message
//   const renderOrderFeedbackMessage = (message) => {
//     return (
//       <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm max-w-md">
//         <div className="text-sm text-gray-800">
//           {message.split("\n").map((line, idx) => (
//             <p key={idx} className="mb-1">
//               {line}
//             </p>
//           ))}
//         </div>
//       </div>
//     );
//   };

//   // Render text message with optional buttons
//   const renderTextMessage = (content) => {
//     return (
//       <div className="max-w-md">
//         <p className="text-sm text-gray-800">{content.body.text}</p>
//         {content.action?.buttons && renderButtons(content.action.buttons)}
//       </div>
//     );
//   };

//   // Render individual message
//   const renderMessage = (msg, index) => {
//     const isUser = msg.sender === "user";
//     const isItemFeedback = msg.message_id === "feedback_item";
//     const isOrderFeedback = msg.message_id === "feedback_order";
//     const isTextWithButtons = msg.message_id === "irrelevantMessage";

//     return (
//       <div
//         key={index}
//         className={`mb-4 flex ${isUser ? "justify-start" : "justify-end"}`}
//       >
//         <div
//           className={`p-3 rounded-lg ${
//             isUser ? "bg-gray-100 text-primary" : "bg-[#f0f4ff] text-gray-800"
//           }`}
//         >
//           {isItemFeedback && typeof msg.message === "object" ? (
//             renderItemFeedbackMessage(msg.message.content)
//           ) : isOrderFeedback && typeof msg.message === "string" ? (
//             renderOrderFeedbackMessage(msg.message)
//           ) : isTextWithButtons && typeof msg.message === "object" ? (
//             renderTextMessage(msg.message.content)
//           ) : typeof msg.message === "string" ? (
//             <p className="text-sm">{msg.message}</p>
//           ) : (
//             <pre className="text-xs">{JSON.stringify(msg.message, null, 2)}</pre>
//           )}
//           <small
//             className={`text-xs opacity-70 block mt-1 ${
//               isUser ? "text-left" : "text-right"
//             }`}
//           >
//             {new Date(msg.timestamp).toLocaleTimeString()}
//           </small>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="bg-[#fffdfc] relative h-full w-full flex flex-col">
//       {/* Header with phone number */}
//       <div className="bg-primary text-white p-4 text-lg font-semibold">
//         Conversation with {name ? name : phone}
//       </div>

//       {/* Messages container */}
//       <div className="flex-1 overflow-y-auto hide-scrollbar p-5 flex flex-col">
//         {loading ? (
//           <div className="flex-1 flex items-center justify-center">
//             <p className="text-gray-500">Loading...</p>
//           </div>
//         ) : error ? (
//           <div className="flex-1 flex items-center justify-center">
//             <p className="text-red-500">{error}</p>
//           </div>
//         ) : conversation.length > 0 ? (
//           conversation.map(renderMessage)
//         ) : (
//           <div className="flex-1 flex items-center justify-center">
//             <p className="text-gray-500">No messages yet</p>
//           </div>
//         )}
//         <div ref={messagesEndRef} />
//       </div>
//     </div>
//   );
// };

// export default Chat;

// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import { getCookie } from "../config/webStorage";

// const Chat = ({ conversationPhone }) => {
//   const token = getCookie("sctoken");
//   const messagesEndRef = useRef(null);
//   const [conversation, setConversation] = useState([]);
//   const [phone, setPhone] = useState("");
//   const [name, setName] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch conversation data from API
//   useEffect(() => {
//     const fetchConversation = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const response = await axios.post(
//           `${apiurl}/apis/getMessagesByPhone`,
//           { phone: conversationPhone },
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         if (response.data.success) {
//           setConversation(response?.data?.messages || []);
//           setPhone(response?.data?.data?.phone);
//           setName(response?.data?.data?.name);
//         } else {
//           setError("Failed to load conversation");
//         }
//       } catch (err) {
//         setError("Error fetching conversation: " + err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (conversationPhone) {
//       fetchConversation();
//     }
//   }, [conversationPhone, token]);

//   // Scroll to bottom on mount and when conversation updates
//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [conversation]);

//   // Render buttons for messages with actions
//   const renderButtons = (buttons) => {
//     return (
//       <div className="mt-2 flex flex-wrap gap-2">
//         {buttons.map((button, idx) => (
//           <button
//             key={button.id || idx}
//             className="px-3 py-1 bg-primary text-white rounded-md hover:bg-primary-dark transition-colors text-sm"
//             onClick={() => console.log(`Button clicked: ${button.id}`)} // Replace with actual handler
//           >
//             {button.title}
//           </button>
//         ))}
//       </div>
//     );
//   };

//   // Render array-based messages (e.g., main menu)
//   const renderArrayMessage = (items) => {
//     return (
//       <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-md">
//         {items.map((item, index) => (
//           <div
//             key={item.id || index}
//             className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow cursor-pointer"
//           >
//             <h3 className="text-lg font-semibold text-primary">{item.title}</h3>
//             <p className="text-sm text-gray-600">{item.description}</p>
//           </div>
//         ))}
//       </div>
//     );
//   };

//   // Render item feedback message (with image, body, footer, buttons)
//   const renderItemFeedbackMessage = (content) => {
//     return (
//       <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm max-w-md">
//         {content.header?.type === "IMAGE" && (
//           <img
//             src={content.header.mediaUrl}
//             alt="Item"
//             className="w-full h-40 object-cover rounded-md mb-3"
//             onError={(e) => (e.target.src = "https://via.placeholder.com/150")} // Fallback image
//           />
//         )}
//         <div className="text-sm text-gray-800">
//           {content.body?.text.split("\n").map((line, idx) => (
//             <p key={idx} className="mb-1">
//               {line}
//             </p>
//           ))}
//         </div>
//         {content.footer?.text && (
//           <p className="text-xs text-gray-500 mt-2">{content.footer.text}</p>
//         )}
//         {content.action?.buttons && renderButtons(content.action.buttons)}
//       </div>
//     );
//   };

//   // Render order feedback message
//   const renderOrderFeedbackMessage = (message) => {
//     return (
//       <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm max-w-md">
//         <div className="text-sm text-gray-800">
//           {message.split("\n").map((line, idx) => (
//             <p key={idx} className="mb-1">
//               {line}
//             </p>
//           ))}
//         </div>
//       </div>
//     );
//   };

//   // Render text message with optional buttons
//   const renderTextMessage = (content) => {
//     return (
//       <div className="max-w-md">
//         <p className="text-sm text-gray-800">{content.body.text}</p>
//         {content.action?.buttons && renderButtons(content.action.buttons)}
//       </div>
//     );
//   };

//   // Render login message (with text, buttons, footer)
//   const renderLoginMessage = (content) => {
//     return (
//       <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm max-w-md">
//         <p className="text-sm text-gray-800 mb-2">{content.body.text}</p>
//         {content.action?.buttons && renderButtons(content.action.buttons)}
//         {content.footer?.text && (
//           <p className="text-xs text-gray-500 mt-2">{content.footer.text}</p>
//         )}
//       </div>
//     );
//   };

//   // Render individual message
//   const renderMessage = (msg, index) => {
//     const isUser = msg.sender === "user";
//     const isItemFeedback = msg.message_id === "feedback_item";
//     const isOrderFeedback = msg.message_id === "feedback_order";
//     const isTextWithButtons = msg.message_id === "irrelevantMessage";
//     const isLoginMessage = msg.message_id === "login";
//     const isMainMenu = msg.message_id === "main menu";

//     return (
//       <div
//         key={index}
//         className={`mb-4 flex ${isUser ? "justify-start" : "justify-end"}`}
//       >
//         <div
//           className={`p-3 rounded-lg ${
//             isUser ? "bg-gray-100 text-primary" : "bg-[#f0f4ff] text-gray-800"
//           }`}
//         >
//           {isItemFeedback && typeof msg.message === "object" ? (
//             renderItemFeedbackMessage(msg.message.content)
//           ) : isOrderFeedback && typeof msg.message === "string" ? (
//             renderOrderFeedbackMessage(msg.message)
//           ) : isTextWithButtons && typeof msg.message === "object" ? (
//             renderTextMessage(msg.message.content)
//           ) : isLoginMessage && typeof msg.message === "object" ? (
//             renderLoginMessage(msg.message.content)
//           ) : isMainMenu && Array.isArray(msg.message) ? (
//             renderArrayMessage(msg.message)
//           ) : typeof msg.message === "string" ? (
//             <p className="text-sm">{msg.message}</p>
//           ) : (
//             <pre className="text-xs">{JSON.stringify(msg.message, null, 2)}</pre>
//           )}
//           <small
//             className={`text-xs opacity-70 block mt-1 ${
//               isUser ? "text-left" : "text-right"
//             }`}
//           >
//             {new Date(msg.timestamp).toLocaleTimeString()}
//           </small>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="bg-[#fffdfc] relative h-full w-full flex flex-col">
//       {/* Header with phone number */}
//       <div className="bg-primary text-white p-4 text-lg font-semibold">
//         Conversation with {name ? name : phone}
//       </div>

//       {/* Messages container */}
//       <div className="flex-1 overflow-y-auto hide-scrollbar p-5 flex flex-col">
//         {loading ? (
//           <div className="flex-1 flex items-center justify-center">
//             <p className="text-gray-500">Loading...</p>
//           </div>
//         ) : error ? (
//           <div className="flex-1 flex items-center justify-center">
//             <p className="text-red-500">{error}</p>
//           </div>
//         ) : conversation.length > 0 ? (
//           conversation.map(renderMessage)
//         ) : (
//           <div className="flex-1 flex items-center justify-center">
//             <p className="text-gray-500">No messages yet</p>
//           </div>
//         )}
//         <div ref={messagesEndRef} />
//       </div>
//     </div>
//   );
// };

// export default Chat;

import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { apiurl } from "../config/config";
import { getCookie } from "../config/webStorage";

const Chat = ({ conversationPhone }) => {
  const token = getCookie("sctoken");
  const messagesEndRef = useRef(null);
  const [conversation, setConversation] = useState([]);
  // const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // console.log("phone",phone)
  // console.log("name",name)

  // Fetch conversation data from API
  useEffect(() => {
    const fetchConversation = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.post(
          `${apiurl}/apis/getMessagesByPhone`,
          { phone: conversationPhone },
          { headers: { Authorization: `Bearer ${token}` } },
        );
        if (response.data.success) {
          // setConversation(response?.data?.messages || []);
          const msgs = response?.data?.messages || [];
          setConversation(msgs.reverse());
          // setPhone(response?.data?.data?.phone);
          setName(response?.data?.name);
        } else {
          setError("Failed to load conversation");
        }
      } catch (err) {
        setError("Error fetching conversation: " + err.message);
      } finally {
        setLoading(false);
      }
    };

    if (conversationPhone) {
      fetchConversation();
    }
  }, [conversationPhone, token]);

  // Scroll to bottom on mount and when conversation updates
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [conversation]);

  // Render buttons for messages with actions
  const renderButtons = (buttons) => {
    return (
      <div className="mt-2 flex flex-wrap gap-2">
        {buttons.map((button, idx) => (
          <button
            key={button.id || idx}
            className="px-3 py-1 bg-primary text-white rounded-md hover:bg-primary-dark transition-colors text-sm"
            onClick={() => console.log(`Button clicked: ${button.id}`)} // Replace with actual handler
          >
            {button.title}
          </button>
        ))}
      </div>
    );
  };

  // Render array-based messages (e.g., main menu)
  const renderArrayMessage = (items) => {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-md">
        {items.map((item, index) => (
          <div
            key={item.id || index}
            className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow cursor-pointer"
          >
            <h3 className="text-lg font-semibold text-primary">{item.title}</h3>
            <p className="text-sm text-gray-600">{item.description}</p>
          </div>
        ))}
      </div>
    );
  };

  // Render item feedback message (with image, body, footer, buttons)
  const renderItemFeedbackMessage = (content) => {
    return (
      <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm max-w-md">
        {content.header?.type === "IMAGE" && (
          <img
            src={content.header.mediaUrl}
            alt="Item"
            className="w-full h-40 object-cover rounded-md mb-3"
            onError={(e) => (e.target.src = "https://via.placeholder.com/150")} // Fallback image
          />
        )}
        <div className="text-sm text-gray-800">
          {content.body?.text.split("\n").map((line, idx) => (
            <p key={idx} className="mb-1">
              {line}
            </p>
          ))}
        </div>
        {content.footer?.text && (
          <p className="text-xs text-gray-500 mt-2">{content.footer.text}</p>
        )}
        {content.action?.buttons && renderButtons(content.action.buttons)}
      </div>
    );
  };

  // Render order feedback message
  const renderOrderFeedbackMessage = (message) => {
    return (
      <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm max-w-md">
        <div className="text-sm text-gray-800">
          {message.split("\n").map((line, idx) => (
            <p key={idx} className="mb-1">
              {line}
            </p>
          ))}
        </div>
      </div>
    );
  };

  // Render text message with optional buttons
  const renderTextMessage = (content) => {
    return (
      <div className="max-w-md">
        <p className="text-sm text-gray-800">{content.body.text}</p>
        {content.action?.buttons && renderButtons(content.action.buttons)}
      </div>
    );
  };

  // Render login message (with text, buttons, footer)
  const renderLoginMessage = (content) => {
    return (
      <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm max-w-md">
        <p className="text-sm text-gray-800 mb-2">{content.body.text}</p>
        {content.action?.buttons && renderButtons(content.action.buttons)}
        {content.footer?.text && (
          <p className="text-xs text-gray-500 mt-2">{content.footer.text}</p>
        )}
      </div>
    );
  };

  // Render individual message
  const renderMessage = (msg, index) => {
    const isUser = msg.sender === "user";
    const isItemFeedback = msg.message_id === "feedback_item";
    const isOrderFeedback = msg.message_id === "feedback_order";
    const isTextWithButtons = msg.message_id === "irrelevantMessage";
    const isLoginMessage = msg.message_id === "login";
    // const isMainMenu = msg.message_id === "main menu";
    const isMainMenu =
      msg.message_id === "main menu" ||
      msg.message_id === "Issue Not Listed" ||
      msg.message_id === "Online Feedback" ||
      msg.message_id === "Customer Feedback";
    const isEndMessage = msg.message_id === "end";
    const isSecretMessage = msg.message_id === "secret";
    const maskedMessage = isSecretMessage ? "****" : msg.message;

    return (
      <div
        key={index}
        className={`mb-4 flex ${isUser ? "justify-start" : "justify-end"}`}
      >
        <div
          className={`p-3 rounded-lg ${
            isUser ? "bg-gray-100 text-primary" : "bg-[#f0f4ff] text-gray-800"
          }`}
        >
          {isSecretMessage && typeof msg.message === "string" ? (
            <p className="text-sm">{maskedMessage}</p>
          ) : isItemFeedback && typeof msg.message === "object" ? (
            renderItemFeedbackMessage(msg.message.content)
          ) : isOrderFeedback && typeof msg.message === "string" ? (
            renderOrderFeedbackMessage(msg.message)
          ) : (isTextWithButtons || isEndMessage) &&
            typeof msg.message === "object" ? (
            renderTextMessage(msg.message.content)
          ) : isLoginMessage && typeof msg.message === "object" ? (
            renderLoginMessage(msg.message.content)
          ) : isMainMenu && Array.isArray(msg.message) ? (
            renderArrayMessage(msg.message)
          ) : typeof msg.message === "string" ? (
            <p className="text-sm break-words whitespace-pre-wrap">
              {msg.message}
            </p>
          ) : (
            <pre className="text-xs break-words whitespace-pre-wrap">
              {JSON.stringify(msg.message, null, 2)}
            </pre>
          )}
          <small
            className={`text-xs opacity-70 block mt-1 ${
              isUser ? "text-left" : "text-right"
            }`}
          >
            {new Date(msg.timestamp).toLocaleTimeString()}
          </small>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-[#fffdfc] relative h-full w-full flex flex-col">
      {/* Header with phone number */}
      <div className="bg-primary text-white p-4 text-lg font-semibold">
        Conversation with {name}
      </div>

      {/* Messages container */}
      <div className="flex-1 overflow-y-auto hide-scrollbar p-5 flex flex-col">
        {loading ? (
          <div className="flex-1 flex items-center justify-center">
            <p className="text-gray-500">Loading...</p>
          </div>
        ) : error ? (
          <div className="flex-1 flex items-center justify-center">
            <p className="text-red-500">{error}</p>
          </div>
        ) : conversation.length > 0 ? (
          conversation.map(renderMessage)
        ) : (
          <div className="flex-1 flex items-center justify-center">
            <p className="text-gray-500">No messages yet</p>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
};

export default Chat;
